module.exports = __webpack_public_path__ + "img/9_no.bf1249dd.svg";